import React, { useState } from "react";
import { css } from "@emotion/react";
import { space } from "main/javascripts/styles/base/spaceStyle";
import { CruiseVesselAttractionList } from "main/javascripts/components/cruise/CruiseVesselAttractionList";
import { CruiseVesselAttractionFilterButton } from "main/javascripts/components/cruise/CruiseVesselAttractionFilterButton";
import { vesselAttractionPreferredOrder } from "main/javascripts/constants/VesselAttractionCategories";
import { Cruise } from "main/javascripts/types/cruise";

export interface IProps {
  vessel: Cruise.Vessel;
}

export const LpCruiseVesselAttractions: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { vessel } = props;

  const uniqueCategories = Array.from(
    new Set(vessel.vesselAttractions.map((attraction) => attraction.category))
  ).sort((a, b) => {
    const indexA = vesselAttractionPreferredOrder.indexOf(a);
    const indexB = vesselAttractionPreferredOrder.indexOf(b);

    // 存在しないカテゴリーは末尾に配置
    const orderA =
      indexA === -1 ? vesselAttractionPreferredOrder.length : indexA;
    const orderB =
      indexB === -1 ? vesselAttractionPreferredOrder.length : indexB;

    return orderA - orderB;
  });

  const firstCategory = uniqueCategories?.[0] || "";
  const [currentCategory, setCurrentCategory] = useState(firstCategory);

  const onFilterClick = (category: string) => {
    setCurrentCategory(category);
  };

  return (
    <div css={blockStyle}>
      <div css={filterBlockStyle}>
        {uniqueCategories?.map((category) => (
          <CruiseVesselAttractionFilterButton
            category={category}
            currentCategory={currentCategory}
            onClick={onFilterClick}
            key={category}
          />
        ))}
      </div>
      <div css={attractionListStyle}>
        <CruiseVesselAttractionList
          attractions={vessel.vesselAttractions}
          category={currentCategory}
        />
      </div>
    </div>
  );
};

const blockStyle = css`
  width: 100%;
`;
const filterBlockStyle = css`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-top: ${space.atom2x};
  display: flex;
  gap: ${space.atom2x};
  padding: ${space.atom2x} 0;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
  &::-webkit-scrollbar {
    display: none;
  }
`;
const attractionListStyle = css`
  padding: ${space.atom2x} 0;
`;
